import { render, staticRenderFns } from "./MapFollow.v2.vue?vue&type=template&id=487b0ba1&"
import script from "./MapFollow.v2.vue?vue&type=script&lang=js&"
export * from "./MapFollow.v2.vue?vue&type=script&lang=js&"
import style0 from "./MapFollow.v2.vue?vue&type=style&index=0&id=487b0ba1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports